export type ProjectIconType = "icon" | "image";

export const DEFAULT_PROJECT_ICON = "circle-check";
